import React, { useState } from "react";
import { useEffect } from "react";
import {
    checkManualBonusEligibility,
    CheckReloadBonusEligible,
    EnrollmentWithNoFormForManualItem,
    getCampaignAssignedClaimsData,
    GetCampaignListWithId,
} from "../../data/wallet";
import promotionErrorConfigModule from "../promotionModalConfigModule";
import { oneWalletHelperModule } from "../oneWalletHelperModule";
import { useDispatch, useSelector } from "react-redux";
import { sendPiwikEvent } from "../../actions/piwikUtil";
import { isGuest, showErrorToast, showSuccessToast } from "../../actions/helper";
import Router from "next/router";
import { promotionActions } from "../../store/promotionSlice";
import { Bounce, toast, Zoom } from "react-toastify";
import { Modal, Tooltip } from "antd";
import PromotionManualPromotionApplicationForm from "../Wallet/OWForm/PromotionManualPromotionApplicationForm";
import ReloadBonusApplicationForm from "../Wallet/OWForm/ReloadBonusApplicationForm";
import { promotionStatusMapping } from "../Wallet/OWForm/OWutil";
import { enumCampaignEntryPeriodDisplayStatus } from "../../actions/constantsData";
import { formatAmount } from "../../actions/util";
import AssignedClaimToStartForm from "../Wallet/OWForm/AssignedClaimToStartForm";

const ManualBonusStatusEnums = (status, isModal) => {
    return {
        REQUIRED_LOGIN: (
            <div
                style={{
                    color: "#00A6FF",
                }}
            >
                Đăng ký ngay{" "}
                <span
                    style={{
                        filter: "brightness(100) saturate(100%) invert(39%) sepia(96%) saturate(3106%) hue-rotate(189deg) brightness(100%) contrast(100%)",
                    }}
                >
                    <img src="/vn/img/1wallet/00/arw3.svg" alt="ArrowRight" />
                </span>
            </div>
        ),
        NO_FORM: (
            <div
                style={{
                    color: "#00A6FF",
                }}
            >
                Đăng ký ngay{" "}
                <span
                    style={{
                        filter: "brightness(100) saturate(100%) invert(39%) sepia(96%) saturate(3106%) hue-rotate(189deg) brightness(100%) contrast(100%)",
                    }}
                >
                    <img src="/vn/img/1wallet/00/arw3.svg" alt="ArrowRight" />
                </span>
            </div>
        ),
        READY_TO_ENROLL: (
            <div
                style={
                    isModal
                        ? {
                              color: "#FFF",
                              width: "345px",
                              backgroundColor: "#00A6FF",
                              borderRadius: "5px",
                              height: "50px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                          }
                        : {
                              color: "#00A6FF",
                              cursor: "pointer",
                          }
                }
            >
                Đăng ký ngay{" "}
                {isModal ? null : (
                    <span
                        style={{
                            filter: "brightness(100) saturate(100%) invert(39%) sepia(96%) saturate(3106%) hue-rotate(189deg) brightness(100%) contrast(100%)",
                        }}
                    >
                        <img
                            src="/vn/img/1wallet/00/arw3.svg"
                            alt="ArrowRight"
                        />
                    </span>
                )}
            </div>
        ),
        PENDING_RESULT: (
            <div
                style={
                    isModal ? {
                        width: "345px",
                        backgroundColor: "#E3E3E3",
                        borderRadius: "5px",
                        padding: "8px",
                        color: "#999999",
                        textAlign:"center",
                        cursor: "not-allowed",
                        fontSize: "16px",
                        height: "50px",
                        alignContent: "center",
                    } :
                    {
                    color: "#999999",
                    backgroundColor: "#E3E3E3",
                    borderRadius: "5px",
                    padding: "5px",
                }}
            >
                Đang xem xét
            </div>
        ),
        START_TO_CLAIM: (
            <div
                style={
                    isModal ? {
                        width: "345px",
                        backgroundColor: "#00A6FF",
                        borderRadius: "5px",
                        padding: "8px",
                        color: "#FFFFFF",
                        textAlign:"center",
                        cursor: "pointer",
                        fontSize: "16px",
                        height: "50px",
                        alignContent: "center",
                    } :
                    {
                    color: "#FFFFFF",
                    backgroundColor: "#00A6FF",
                    borderRadius: "5px",
                    padding: "5px",
                    fontSize: "10px",
                    height: "32px",
                    alignContent: "center",
                }}
            >
                Bắt đầu khuyến mãi
            </div>
        ),
        ALREADY_APPLIED: (
            <div
                style={
                    isModal ? {
                        width: "345px",
                        backgroundColor: "#E3E3E3",
                        borderRadius: "5px",
                        padding: "8px",
                        color: "#999999",
                        textAlign:"center",
                        cursor: "not-allowed",
                    } :
                    {
                    color: "#999999",
                    backgroundColor: "#E3E3E3",
                    borderRadius: "5px",
                    padding: "5px",
                }}
            >
                Đã đăng ký
            </div>
        ),
        ALREADY_CLAIMED: (
            <div
                style={
                    isModal ? {
                        width: "345px",
                        backgroundColor: "#E3E3E3",
                        borderRadius: "5px",
                        padding: "8px",
                        color: "#999999",
                        textAlign:"center",
                        cursor: "not-allowed",
                        fontSize: "16px",
                        height: "50px",
                        alignContent: "center",
                    } :
                    {
                    color: "#999999",
                    backgroundColor: "#E3E3E3",
                    borderRadius: "5px",
                    padding: "5px",
                }}
            >
                Đã nhận
            </div>
        ),
        NO_ACTION: isModal ? (
            null
        ) : (
            <div
                style={{
                    color: "#00A6FF",
                }}
            >
                 Xem chi tiết{" "}
                <span
                    style={{
                        filter: "brightness(100) saturate(100%) invert(39%) sepia(96%) saturate(3106%) hue-rotate(189deg) brightness(100%) contrast(100%)",
                    }}
                >
                    <img
                        src="/vn/img/1wallet/00/arw3.svg"
                        alt="ArrowRight"
                    />
                </span>
            </div>
        ),
        APPLY_FORM: (
            <div
                style={
                    isModal
                        ? {
                              color: "#FFF",
                              width: "345px",
                              backgroundColor: "#00A6FF",
                              borderRadius: "5px",
                              height: "50px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                          }
                        : {
                              color: "#00A6FF",
                              cursor: "pointer",
                          }
                }
            >
                Đăng ký ngay{" "}
                {isModal ? null : (
                    <span
                        style={{
                            filter: "brightness(100) saturate(100%) invert(39%) sepia(96%) saturate(3106%) hue-rotate(189deg) brightness(100%) contrast(100%)",
                        }}
                    >
                        <img
                            src="/vn/img/1wallet/00/arw3.svg"
                            alt="ArrowRight"
                        />
                    </span>
                )}
            </div>
        ),
        FUND_IN: (
            <div
                style={
                    isModal
                        ? {
                              color: "#FFF",
                              width: "345px",
                              backgroundColor: "#00A6FF",
                              borderRadius: "5px",
                              height: "50px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                          }
                        : {
                              color: "#00A6FF",
                              cursor: "pointer",
                          }
                }
            >
                Đăng ký ngay{" "}
                {isModal ? null : (
                    <span
                        style={{
                            filter: "brightness(100) saturate(100%) invert(39%) sepia(96%) saturate(3106%) hue-rotate(189deg) brightness(100%) contrast(100%)",
                        }}
                    >
                        <img
                            src="/vn/img/1wallet/00/arw3.svg"
                            alt="ArrowRight"
                        />
                    </span>
                )}
            </div>
        ),
        VIEW_DETAILS: isModal ? null : (
            <div
                style={{
                    color: "#00A6FF",
                }}
            >
                 Xem chi tiết{" "}
                <span
                    style={{
                        filter: "brightness(100) saturate(100%) invert(39%) sepia(96%) saturate(3106%) hue-rotate(189deg) brightness(100%) contrast(100%)",
                    }}
                >
                    <img
                        src="/vn/img/1wallet/00/arw3.svg"
                        alt="ArrowRight"
                    />
                </span>
            </div>
        ),
    };
};

const ActionTypeEnums = {
    FUND_IN: "FUND_IN",
    APPLY_FORM: "APPLY_FORM",
    NO_FORM: "NO_FORM",
    NO_ACTION: "NO_ACTION",
    DEPOSIT_PAGE_ONLY: "DEPOSIT_PAGE_ONLY",
};

function OneWalletPromotionPageButton({
    data,
    withinTnCmodal = false,
    openApplicationModal = () => {},
    openErrorModal = () => {},
    showToastAfterSuccess = () => {},
    showToastAfterFailure = () => {},
    onClose = () => {}
}) {
    const [bonus, setBonus] = useState({});
    const [btnObj, setBtnObj] = useState({});
    const [isLogin, setIsLogin] = useState(false);
    const userCenter = useSelector((state) => state.userCenter);
    const [PromotionManualPromotionApplicationFormVisible, setPromotionManualPromotionApplicationFormVisible] = useState(false);
    const [ReloadBonusApplicationFormVisible, setReloadBonusApplicationFormVisible] = useState(false);
    const [thatAssigenedBonus, setThatAssigenedBonus] = useState({});
    const [isClaimToStartFormVisible, setClaimToStartFormVisible] = useState(false);
    // console.log("OneWalletPromotionPageButtonData", data);
    const dispatch = useDispatch();

    useEffect(() => {
        // Check for window object and access token in localStorage
        if (typeof window !== "undefined") {
            const token = localStorage.getItem("access_token");
            setIsLogin(!!token);
        }
    }, []);

    const handleActionBtn = async () => {
        console.log("bonus?.datafisrttt", bonus);
        console.log("bonus?.actionType221", withinTnCmodal, bonus?.campaignId);
        if (withinTnCmodal) {
            Pushgtagdata(
                `Promotion`,
                "Start Promotion",
                "Promotion_C_StartPromotion",
                "",
                [
                    {customVariableKey: "Promotion_C_StartPromotion_PromoName_PrmoID",
                    customVariableValue: `${bonus?.promoTitle}_${bonus?.promoId}`},
                ]
                
            );
            console.log("bonus?.campaignId22", bonus?.campaignId);
            if (bonus?.isManualPreBonus || bonus?.isManualItem) {
                if(bonus?.campaignRow?.entryPeriod?.displayStatus === "START_TO_CLAIM") {
                    console.log("bonus?.campaignRow?.entryPeriod?.displayStatusInner", bonus?.campaignRow?.entryPeriod?.displayStatus);
                    let _participantId = bonus?.campaignRow?.participant?.id;
                    let assignedBonus = await getCampaignAssignedClaimsData();
                    console.log("assignedBonus", assignedBonus);
                    let thatBonusData = assignedBonus.find((item) => item?.participantId === _participantId);
                    console.log("thatBonusData", thatBonusData);
                    if(thatBonusData?.participantId ||thatAssigenedBonus?.campaignId) {
                        setThatAssigenedBonus(thatBonusData);
                        setClaimToStartFormVisible(true);
                    } else {
                        showErrorToast();
                    }
                    return;
                }
                fetchEligibilityForManulBonus(
                    bonus?.campaignRow?.entryPeriod?.id
                ).then((rsp) => {
                    console.log("rsprsprsp11", rsp);
                    if (rsp?.isSuccess && rsp?.result?.isSuccess) {
                        console.log("rsp?.resultFail", rsp);
                        if (bonus?.actionType === ActionTypeEnums.APPLY_FORM) {
                            setPromotionManualPromotionApplicationFormVisible(true);
                            
                        } else if (
                            bonus?.actionType === ActionTypeEnums.NO_FORM &&
                            bonus?.campaignRow?.entryPeriod?.id // handle manual item without form
                        ) {
                            EnrollmentWithNoFormForManualItem(
                                { id: bonus?.campaignRow?.entryPeriod?.id } //need checks
                            ).then((rsp) => {
                                console.log("rsprsprsp11", rsp);
                                if (rsp?.isSuccess && rsp?.result?.isSuccess) {
                                    console.log(
                                        "rsp?.EnrollmentWithNoFormForManualItem",
                                        rsp
                                    );
                                    showToastAfterSuccess();
                                    Router.router.push("/promotions");
                                } else {
                                    showToastAfterFailure();
                                    openErrorModal(rsp?.result);
                                }
                            });
                        }
                    } else {
                        console.log("rsp?.resultFail", rsp);
                        openErrorModal(rsp?.result);
                    }
                });
            } else if (bonus?.isReloadBonus) {
                console.log("bonus?.isReloadBonus", bonus);
                let mainWallet = userCenter?.balanceInfo?.balances?.find(
                    (wallet) => wallet.walletProductGroupId === 1
                );
                console.log("mainWallet", mainWallet);
                if (
                    mainWallet?.balance <= bonus?.bonusData?.minAccept ||
                    mainWallet?.balance <= bonus?.bonusMinAmount
                ) {
                    openErrorModal(
                        { errorCode: "inSufficientBalance" },
                        true,
                        bonus
                    );
                    return;
                }
                CheckReloadBonusEligible({
                    id: oneWalletHelperModule.getBonusGroupId(bonus),
                }).then((rsp) => {
                    console.log("rsprsprsp33", rsp);
                    if (rsp?.isSuccess && rsp?.result?.isEligible) {

                        setReloadBonusApplicationFormVisible(true)
                    } else {
                        openErrorModal(rsp?.result, true, bonus);
                    }
                });
            }
        }
    };

    const handleBtnTxtAndActionWithoutLogin = async () => {
        console.log("bonus?.actionTypen", bonus?.actionType);
        switch (bonus?.actionType) {
            case ActionTypeEnums.FUND_IN:
                console.log("FUNF_INzz", bonus, withinTnCmodal);
                return {
                    content: (
                        <div
                            style={
                                withinTnCmodal
                                    ? {
                                          color: "#FFF",
                                          width: "345px",
                                          backgroundColor: "#00A6FF",
                                          borderRadius: "5px",
                                          height: "50px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          cursor: "pointer",
                                      }
                                    : {
                                          color: "#00A6FF",
                                          cursor: "pointer",
                                      }
                            }
                        >
                            Đăng ký ngay{" "}
                            {withinTnCmodal ? null : (
                                <span
                                    style={{
                                        filter: "brightness(100) saturate(100%) invert(39%) sepia(96%) saturate(3106%) hue-rotate(189deg) brightness(100%) contrast(100%)",
                                    }}
                                >
                                    <img
                                        src="/vn/img/1wallet/00/arw3.svg"
                                        alt="ArrowRight"
                                    />
                                </span>
                            )}
                        </div>
                    ),
                    action: () => {
                        console.log("Reload");
                        if (withinTnCmodal) global.goUserSign("1");
                    },
                };
            case ActionTypeEnums.APPLY_FORM:
                return {
                    content: (
                        <div
                            style={
                                withinTnCmodal
                                    ? {
                                          color: "#FFF",
                                          width: "345px",
                                          backgroundColor: "#00A6FF",
                                          borderRadius: "5px",
                                          height: "50px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          cursor: "pointer",
                                      }
                                    : {
                                          color: "#00A6FF",
                                          cursor: "pointer",
                                      }
                            }
                        >
                            Đăng ký ngay{" "}
                            {withinTnCmodal ? null : (
                                <span
                                    style={{
                                        filter: "brightness(100) saturate(100%) invert(39%) sepia(96%) saturate(3106%) hue-rotate(189deg) brightness(100%) contrast(100%)",
                                    }}
                                >
                                    <img
                                        src="/vn/img/1wallet/00/arw3.svg"
                                        alt="ArrowRight"
                                    />
                                </span>
                            )}
                        </div>
                    ),
                    action: () => {
                        console.log("Apply");
                        if (withinTnCmodal) global.goUserSign("1");
                    },
                };
            case ActionTypeEnums.NO_FORM:
                return {
                    content: (
                        <div
                            style={
                                withinTnCmodal
                                    ? {
                                          color: "#FFF",
                                          width: "345px",
                                          backgroundColor: "#00A6FF",
                                          borderRadius: "5px",
                                          height: "50px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          cursor: "pointer",
                                      }
                                    : {
                                          color: "#00A6FF",
                                          cursor: "pointer",
                                      }
                            }
                        >
                            Đăng ký ngay{" "}
                            {withinTnCmodal ? null : (
                                <span
                                    style={{
                                        filter: "brightness(100) saturate(100%) invert(39%) sepia(96%) saturate(3106%) hue-rotate(189deg) brightness(100%) contrast(100%)",
                                    }}
                                >
                                    <img
                                        src="/vn/img/1wallet/00/arw3.svg"
                                        alt="ArrowRight"
                                    />
                                </span>
                            )}
                        </div>
                    ),
                    action: () => {
                        console.log("Claim");
                        if (withinTnCmodal) global.goUserSign("1");
                    },
                };
            case ActionTypeEnums.NO_ACTION:
                return {
                    content: withinTnCmodal ? null : (
                        <div
                            style={
                                withinTnCmodal
                                    ? {
                                          color: "#FFF",
                                          width: "345px",
                                          backgroundColor: "#00A6FF",
                                          borderRadius: "5px",
                                          height: "50px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          cursor: "pointer",
                                      }
                                    : {
                                          color: "#00A6FF",
                                          cursor: "pointer",
                                      }
                            }
                        >
                            Đăng ký ngay{" "}
                            {withinTnCmodal ? null : (
                                <span
                                    style={{
                                        filter: "brightness(100) saturate(100%) invert(39%) sepia(96%) saturate(3106%) hue-rotate(189deg) brightness(100%) contrast(100%)",
                                    }}
                                >
                                    <img
                                        src="/vn/img/1wallet/00/arw3.svg"
                                        alt="ArrowRight"
                                    />
                                </span>
                            )}
                        </div>
                    ),
                    action: () => {
                        console.log("Claim");
                        if (withinTnCmodal) global.goUserSign("1");
                    },
                };
            default:
                console.log("defaultssss", bonus?.actionType, bonus);
                return {
                    content: <div>Claim</div>,
                    action: () => {
                        console.log("Claim");
                        if (withinTnCmodal) global.goUserSign("1");
                    },
                };
        }
    };

    const fetchEligibilityForManulBonus = async (campaignId) => {
        let statusResp = await checkManualBonusEligibility(campaignId);
        console.log("fetchEligibilityForManulBonus", statusResp);
        return statusResp;
    };

    const handleCampaignStatusTxt = (status, isModal = false) => {
        console.log("status", status, isModal);
        const statusComponent = ManualBonusStatusEnums(status, isModal)[status];
        
        if(withinTnCmodal) {console.log("statusComponent", ManualBonusStatusEnums(status, isModal)["NO_ACTION"]);}
        // Clone the React element and adjust styles if it's in a modal
        return statusComponent;
    };

    const handleBtnTxtAndActionWithLogin = async () => {
        let btnTxtValue = "default";
        let status;
        let result = {};
        let isProcessing = false;
        let isLogin = !isGuest()
    
        const isManual2025 = bonus?.isManualPreBonus || bonus?.isManualItem || false;
        const isReloadBonus = bonus?.isReloadBonus || false;
        const canProcceedToApplyReload = bonus?.bonusData || false;
        const canProceedToApplyManual = bonus?.campaignRow?.entryPeriod?.id || false;
        
        console.log("Handling bonus:", bonus);

        if(withinTnCmodal) {
            console.log("bonus?.actionTypeWithinModal", bonus);
        }
    
        let actionType = bonus?.actionType;
        if(withinTnCmodal) {
            console.log("bonus?.actionTypeWithinModal2", actionType, bonus);
        }
    
        if (isManual2025) {
            if (!canProceedToApplyManual) {
                actionType = "NO_ACTION";
            }
            switch (actionType) {
                case ActionTypeEnums.NO_ACTION:
                    status = "VIEW_DETAILS";
                    result = {
                        content: <div>{handleCampaignStatusTxt(status, withinTnCmodal)}</div>,
                        action: () => console.log("Manual - View Details"),
                    };
                    break;
                case ActionTypeEnums.APPLY_FORM:
                case ActionTypeEnums.NO_FORM:
                    const { entryPeriod } = bonus?.campaignRow || {};
                    if (entryPeriod) {
                        status = entryPeriod?.displayStatus;
                    } else {
                        status = "VIEW_DETAILS";
                    }
    
                    result = {
                        content: (
                            <div>
                                 {handleCampaignStatusTxt(status, withinTnCmodal)}
                            </div>
                        ),
                        action: async () => {
                            if(["PENDING_RESULT","ALREADY_APPLIED","ALREADY_CLAIMED","NO_ACTION","VIEW_DETAILS"].includes(status)) return;
                            if (isProcessing) return;
                            sendPiwikEvent("Promotion", "Apply Promotion", "Promotion_C_ApplyNow");
                            isProcessing = true;
                            await handleActionBtn();
                            isProcessing = false;
                        },
                    };
                    break;
            }
        } else if (isReloadBonus) {
            if (!canProcceedToApplyReload) {
                actionType = "NO_ACTION";
            }
            switch (actionType) {
                case ActionTypeEnums.NO_ACTION: 
                status = "VIEW_DETAILS";
                result = {
                    content: <div>{handleCampaignStatusTxt(status, withinTnCmodal)}</div>,
                    action: () => console.log("Manual - View Details"),
                };
                break;
                case ActionTypeEnums.FUND_IN:
    
                    const { isApplied } = bonus?.bonusData || {};
                        if (isApplied) {
                            status = "ALREADY_APPLIED";
                        } else {
                            status = actionType;
                        }

                    console.log("btnTxtValue666", status);
                    result = {
                        content: (withinTnCmodal && ["NO_ACTION", "VIEW_DETAILS"].includes(status))
                        ? null :
                        (
                            <div
                                style={{
                                    color: withinTnCmodal ? "#FFF" : "#00A6FF",
                                    backgroundColor: withinTnCmodal ? "#00A6FF" : "transparent",
                                    borderRadius: "5px",
                                    height: "50px",
                                    display: "flex",
                                    alignItems: withinTnCmodal ? "center" : "flex-start",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    width: withinTnCmodal ? "345px" : "auto",
                                }}
                            >
                                 {handleCampaignStatusTxt(status, withinTnCmodal)}
                            </div>
                        ),
                        action: async () => {
                            if(["PENDING_RESULT","ALREADY_APPLIED","ALREADY_CLAIMED","NO_ACTION","VIEW_DETAILS"].includes(status)) return;
                            if (isProcessing) return;
                            isProcessing = true;
                            sendPiwikEvent("Promotion", "Apply Promotion", "Promotion_C_ApplyNow");
                            console.log("Reload - Reload Action");
                            await handleActionBtn();
                            isProcessing = false;
                        },
                    };
                    break;
                case ActionTypeEnums.DEPOSIT_PAGE_ONLY:
                    if (withinTnCmodal && !canProcceedToApplyReload) {
                        return { content: null, action: () => console.log("No action") };
                    }
                    result = {
                        content: (
                            <div
                            style={{
                                color: withinTnCmodal ? "#FFF" : "#00A6FF",
                                backgroundColor: withinTnCmodal ? "#00A6FF" : "transparent",
                                borderRadius: "5px",
                                height: "50px",
                                display: "flex",
                                alignItems: withinTnCmodal ? "center" : "flex-start",
                                justifyContent: "center",
                                cursor: "pointer",
                                width: withinTnCmodal ? "345px" : "auto",
                            }}
                        >
                            Đăng ký ngay {" "}
                            {!withinTnCmodal && (
                                <span style={{ filter: "brightness(100) saturate(100%) invert(39%) sepia(96%) saturate(3106%) hue-rotate(189deg) brightness(100%) contrast(100%)" }}>
                                    <img src="/vn/img/1wallet/00/arw3.svg" alt="ArrowRight" />
                                </span>
                            )}
                        </div>
                        ),
                        action: async () => {
                            if(!withinTnCmodal) return;
                            console.log("Reload - Deposit Action", bonus);
                            dispatch(promotionActions.setOWSelectedBonus(bonus));
                            sessionStorage.setItem(
                                "promoDeposit",
                                JSON.stringify({
                                    bonusId: bonus.bonusId ?? "",
                                    bonusRuleGroupId: bonus?.bonusData?.groupID || 0,
                                    bonusProduct: bonus?.bonusProduct ?? "",
                                    bonusMinAmount: bonus?.bonusMinAmount ?? "",
                                    bonusTitle: bonus?.promoTitle ?? "",
                                    depositingWallet: bonus?.bonusData?.account ?? "",
                                })
                            );
                            global.showDialog({
                                key: 'wallet:{"type": "deposit"}',
                            });
                        },
                    };
                    break;
                    case ActionTypeEnums.NO_ACTION:
                        status = "NO_ACTION";
                        result = {
                            content: <div>{handleCampaignStatusTxt(status, withinTnCmodal)}</div>,
                            action: () => console.log("Manual - View Details"),
                        };
                    break;
            }
        } else {
            result = { content: <div>Claim in else</div>, action: () => console.log("No action") };
        }
    
        return result;
    };
    

    useEffect(() => {
        console.log("OneWalletPromotionPageButton", data);
        setBonus(data);
    }, [data?.campaignId, data?.bonusId]);

    useEffect(() => {
        if (bonus && !isLogin) {
            handleBtnTxtAndActionWithoutLogin().then((result) => {
                setBtnObj(result);
            });
        } else if (bonus && isLogin) {
            handleBtnTxtAndActionWithLogin().then((result) => {
                setBtnObj(result);
            });
        }
    }, [bonus?.campaignId, isLogin]);

    return (
        <>
            <div
                style={{
                    color: "black",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    ...bonus?.style,
                }}
                onClick={btnObj?.action}
            >
                {bonus?.status ===
                    enumCampaignEntryPeriodDisplayStatus.START_TO_CLAIM &&
                withinTnCmodal ? (
                    <Tooltip
                        overlayClassName={"tooltip-dark"}
                        placement="right"
                        title={`Nhận thưởng trả trước ${
                            bonus?.campaignRow?.participant?.givenAmount
                                ? formatAmount(
                                      item.campaignRow.participant.givenAmount
                                  )
                                : ""
                        } đ`}
                    >
                        {btnObj?.content}
                    </Tooltip>
                ) : (
                    btnObj?.content
                )}
            </div>
            <PromotionManualPromotionApplicationForm
                visible={PromotionManualPromotionApplicationFormVisible}
                onClose={() =>
                    setPromotionManualPromotionApplicationFormVisible(false)
                }
                bonus={bonus}
                showToastAfterSuccess={showToastAfterSuccess}
                showToastAfterFailure={showToastAfterFailure}
            />
            <ReloadBonusApplicationForm
                visible={ReloadBonusApplicationFormVisible}
                onClose={() => setReloadBonusApplicationFormVisible(false)}
                bonus={bonus}
                showToastAfterSuccess={showToastAfterSuccess}
                showToastAfterFailure={showToastAfterFailure}
            />
            <AssignedClaimToStartForm
            item={thatAssigenedBonus}
            visible={isClaimToStartFormVisible}
            handleClose={() => setClaimToStartFormVisible(false)}        
            />
        </>
    );
}

export default OneWalletPromotionPageButton;
